export default "__VITE_ASSET__BrAQkFJb__";